import clarity from "@microsoft/clarity";

// Resolve project ID at call time so an env override (typically set at build
// time for non-prod environments) takes precedence over the bundled default.
// If neither is provided, skip cleanly. Any unexpected init failure is
// swallowed so analytics never breaks app startup.
const DEFAULT_CLARITY_PROJECT_ID = "u87ou2y6m5";

const initClarity = () => {
  if (typeof window === "undefined" || window.__CLARITY_INITIALIZED__) {
    return;
  }

  const projectId =
    process.env.REACT_APP_CLARITY_PROJECT_ID || DEFAULT_CLARITY_PROJECT_ID;

  if (!projectId) {
    return;
  }

  try {
    clarity.init(projectId);
    window.__CLARITY_INITIALIZED__ = true;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(
      "Microsoft Clarity init failed; continuing without analytics.",
      error
    );
  }
};

export default initClarity;
